export const uniqueId = (prefix) => {
  return `${prefix}-${(/* @__PURE__ */ new Date()).getTime()}-${Math.random().toString(16).slice(2)}`;
};
